import { render, staticRenderFns } from "./panel_resizer.vue?vue&type=template&id=d0d7a508"
import script from "./panel_resizer.vue?vue&type=script&lang=js"
export * from "./panel_resizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports